/// <reference types="vite/client" />

/**
 * Environment configuration
 * 
 * This file manages environment-specific settings for the application.
 */
const API_CONFIG_DEV_MOCK = {
  BASE_URL: import.meta.env.VITE_API_URL + '/api/v1',
  USE_MOCK_API: true,
  MOCK_API_DELAY: '500',
};

const API_CONFIG_DEV_REAL = {
  BASE_URL: import.meta.env.VITE_API_URL + '/api/v1',
  USE_MOCK_API: false,
  MOCK_API_DELAY: '0',
};

const API_CONFIG_PROD = {
  BASE_URL: import.meta.env.VITE_API_URL + '/api/v1',
  USE_MOCK_API: false,
  MOCK_API_DELAY: '0',
};

// Use import.meta.env for Vite projects
export const API_CONFIG = () => {
  if (import.meta.env.MODE === "development") {
    if (import.meta.env.VITE_USE_MOCK_API === true || import.meta.env.VITE_USE_MOCK_API === "true") {
      return API_CONFIG_DEV_MOCK;
    } else if (import.meta.env.VITE_USE_MOCK_API === false || import.meta.env.VITE_USE_MOCK_API === "false") {
      return API_CONFIG_DEV_REAL;
    }
  } else if (import.meta.env.MODE === "production") { 
    return API_CONFIG_PROD;
  }
  return API_CONFIG_DEV_REAL;
};

// Log configuration in development
if (import.meta.env.MODE === "development") {
  console.log('API Configuration:', {
    baseUrl: API_CONFIG().BASE_URL,
    useMockApi: API_CONFIG().USE_MOCK_API,
    mockDelay: API_CONFIG().MOCK_API_DELAY,
  });
}
